import { render, staticRenderFns } from "./addOrigin.vue?vue&type=template&id=0bf730da&scoped=true&"
import script from "./addOrigin.vue?vue&type=script&lang=js&"
export * from "./addOrigin.vue?vue&type=script&lang=js&"
import style0 from "./addOrigin.vue?vue&type=style&index=0&id=0bf730da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf730da",
  null
  
)

export default component.exports